import React  , { Component } from 'react'

import {  HomeSlider,
          HomeTitle,
          Img       } from '../../Components/UI/UI'

import {getWeather} from '../../Utility/Utility'

import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "./CoronaVirus.css"

class CoronaVirus extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount () {

    getWeather((Weather)=>{
      
      // console.log("Weather", Weather);
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        jerusalemWeather : Weather.jerusalemWeather,
      })

      
    });
    

     
  }
  
  render(){
    return(
      <div className="page align-left page-Corona-virus">
      <Menu />
        <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
          
          <div className="container">
           
           

          
          <p>We wanted to let you know we miss you! We in Israel are doing everything possible to let you back in so you can enjoy all the best Israel offers, making for an unforgettable holiday. We look forward to seeing you soon.</p>
             

           {/*<h1>ISRAEL TRAVEL ALERTS & SAFETY INFORMATION</h1>*/}

           <h2 className="ac-pink">Latest information for tourists to Israel about the Corona virus (covid-19):</h2>

           {/*<h2 className="ac-pink">Israel Has Announced Further Relief Measures</h2> 


            <p>
            As of the 1st of June, Israel's Ministry of Health has announced another series of relief measures, among them, the opening of restaurants, tourist attractions and hotels.
            </p>

            <p>The beaches were opened on May 20th.</p>

            <p>As of May 27th, 2020, restaurants, bars, pubs, and clubs are allowed to open, subject to some restrictions. Leisure and tourist attractions such as hotels, museums and swimming pools are also allowed to open, subject to some restrictions.</p> 

            <p>The ministry of health has also agreed to increase bus and taxi passenger capacity, as well as to resume trains activity, from the 8th of June.</p> 

            <p>Entertainment and leisure activities will resume on June 14th, including event venues and gardens, concerts, theatres, cinema, art and cultural events, subject to some restrictions.</p> 

            <p>In the tourism sector, several countries have announced opening their borders to Israeli citizens:  Greece, Austria, Montenegro, Georgia and now Cyprus (starting June 9th).</p>  

            <p>International airlines such as Delta Airlines, British Airways, Air Canada, Wizz Air, Ryanair, Lufthansa, Turkish Airlines, Alitalia, Ukrainian International and more have announced their intention of resuming commercial flights to and from Israel this summer.</p> */}
            
            <h2 className="ac-pink ac-margin-top-1 ac-bigger">Tourists looking<br className="show-on-mobile"/> to travel to Israel:</h2>

            <p className="ac-align-center">
              <strong>At the moment and until further notice,</strong> entry to Israel is still denied to most non-citizens or non-residents of Israel arriving from anywhere in the world. 
              <strong> The Ministry of Health has permitted a very limited number of vaccinated groups from various countries who were deemed safe, to enter Israel as a study case.</strong>
              <br/>
              We are hoping this test will prove to be successful and allow more and more tourists to enter. More details will be provided as soon as possible.
            </p>
         
            <h2 className="ac-pink ac-bigger"> General guidelines for all<br className="show-on-mobile"/> those staying in Israel: </h2>

            <p>
            As of June 1st, most corona restrictive measures have been lifted in Israel.<br/>
            This includes restrictions on crowd size, which means people can enter entertainment facilities without presenting a vaccination certificate.<br/>
            Wearing masks will remain a requirement only in closed, air-conditioned public places such as shopping malls, trains and busses, shops, offices, etc.
            </p>

            <h2 className="ac-pink">Important! </h2>

            <ul>
              <li>
                If you show any Covid related symptoms such as a fever of 38c or higher, a cough, trouble breathing, or other respiratory symptoms, <strong>you must immediately let your tourist agent and tour guide know and ask for assistance to self-isolate.</strong>
              </li>
            </ul>

            <h2 className="ac-pink">Frequently Asked Questions</h2>

            <ol start="1" className="ac-padding-start ac-pink">
              <li>
                <strong className="ac-pink">I am a tourist in Israel and I am concerned that I may have COVID-19, where should I go?</strong>
              </li>
            </ol>

            <p className="ac-align-left-15">
              If you have a fever of 100.4F (38C) or higher, cough, trouble breathing, or other respiratory symptoms, you must immediately let your tour guide and your agent know. They will provide you with all the relevant measure you will be required to take.
            </p>

            <ol start="2" className="ac-padding-start ac-pink">
              <li>
                <strong className="ac-pink">When will Israel be open to incoming visitors again?</strong>
              </li>
            </ol>

            <p className="ac-align-left-15">At this moment, the State of Israel granted the Ministry of Tourism the permission to start a pilot scheme with a restricted number of groups who will be allowed into Israel under certain conditions. Should this pilot be successful, new information and guidelines will be communicated.</p>



        <div>
        <Img desktopImg={"infection.jpg"} />
        </div>
        </div>

        
      <Footer />
    </div>
    )
    }

}



export default CoronaVirus


// WEBPACK FOOTER //
// ./src/Pages/CoronaVirusPage/CoronaVirus.js